//@author: mandy

import { NgModule } from "@angular/core";
import { S25DatePatternComponent } from "./s25.datepattern.component";
import { S25DatePatternPickerComponent } from "./s25.datepattern.picker.component";

@NgModule({
    imports: [S25DatePatternComponent, S25DatePatternPickerComponent],
    providers: [S25DatePatternComponent, S25DatePatternPickerComponent],
    exports: [S25DatePatternComponent, S25DatePatternPickerComponent],
})
export class S25DatePatternModule {
    constructor() {}
}
